import { render, staticRenderFns } from "./AkHtmlReadOnly.vue?vue&type=template&id=9c1f78f6&"
import script from "./AkHtmlReadOnly.vue?vue&type=script&lang=js&"
export * from "./AkHtmlReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/hens-nv/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1f78f6')) {
      api.createRecord('9c1f78f6', component.options)
    } else {
      api.reload('9c1f78f6', component.options)
    }
    module.hot.accept("./AkHtmlReadOnly.vue?vue&type=template&id=9c1f78f6&", function () {
      api.rerender('9c1f78f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkHtmlReadOnly.vue"
export default component.exports